export const customPhoneValidation = (
  phone: string,
  country?: string
): boolean => {
  if (country === "EG" || phone.startsWith("+20")) {
    return (
      phone.length === 13 &&
      (phone.startsWith("+2010") ||
        phone.startsWith("+2011") ||
        phone.startsWith("+2012") ||
        phone.startsWith("+2015"))
    );
  }
  return true;
};
